import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("abeille-admin-token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (
      error.response?.status === 401 &&
      original &&
      !original._retry &&
      !original.url.includes("/auth/")
    ) {
      original._retry = true;
      const refreshToken = localStorage.getItem("abeille-admin-refresh");
      if (refreshToken) {
        try {
          refreshing =
            refreshing ||
            api.post("/auth/refresh", {}, { headers: { Authorization: `Bearer ${refreshToken}` } });
          const { data } = await refreshing;
          refreshing = null;
          localStorage.setItem("abeille-admin-token", data.access_token);
          localStorage.setItem("abeille-admin-refresh", data.refresh_token);
          return api(original);
        } catch {
          refreshing = null;
          localStorage.removeItem("abeille-admin-token");
          localStorage.removeItem("abeille-admin-refresh");
          if (window.location.pathname.startsWith("/admin") && window.location.pathname !== "/admin/login") {
            window.location.href = "/admin/login";
          }
        }
      }
    }
    return Promise.reject(error);
  }
);

export const formatPrice = (cents) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(cents / 100);

export const FREE_SHIPPING_THRESHOLD = 5000;

export const resolveImage = (url) => {
  if (!url) return "";
  return url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
};

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Une erreur est survenue, réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
